"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePhoneNumber = exports.PhoneNumberValidationError = void 0;
exports.normalizeExistingPhoneNumber = normalizeExistingPhoneNumber;
exports.IsValidPhoneNumber = IsValidPhoneNumber;
const class_validator_1 = require("class-validator");
const libphonenumber_js_1 = __importDefault(require("libphonenumber-js"));
class PhoneNumberValidationError extends Error {
    constructor() {
        super('Invalid phone number format');
        this.name = 'PhoneNumberValidationError';
    }
}
exports.PhoneNumberValidationError = PhoneNumberValidationError;
const normalizePhoneNumber = (value, options = {}) => {
    const { allowEmpty = true, requireE164 = true, region } = options;
    if (value === null || value === undefined || value === '') {
        if (allowEmpty)
            return '';
        throw new PhoneNumberValidationError();
    }
    if (typeof value !== 'string')
        throw new PhoneNumberValidationError();
    if (requireE164 && !/^\+[1-9]\d{1,14}$/.test(value)) {
        throw new PhoneNumberValidationError();
    }
    const phoneNumber = (0, libphonenumber_js_1.default)(value, region);
    if (!phoneNumber?.isValid() || !phoneNumber.countryCallingCode) {
        throw new PhoneNumberValidationError();
    }
    return phoneNumber.number;
};
exports.normalizePhoneNumber = normalizePhoneNumber;
/** Preserve trusted existing values for correction; new user input still requires validation. */
function normalizeExistingPhoneNumber(value) {
    if (!value)
        return { value, requiresCorrection: false };
    try {
        return {
            value: (0, exports.normalizePhoneNumber)(value, { requireE164: false, region: 'US' }),
            requiresCorrection: false,
        };
    }
    catch (error) {
        if (!(error instanceof PhoneNumberValidationError))
            throw error;
        return { value, requiresCorrection: true };
    }
}
function IsValidPhoneNumber(validationOptions = {}) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: 'isValidPhoneNumber',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [validationOptions],
            options: {
                message: 'Invalid phone number format',
                ...validationOptions,
            },
            validator: {
                validate(value, args) {
                    // default to US for old phone numbers eg - (888) 888 8888
                    const { region = 'US', allowEmpty = false, requireE164 = false, } = args.constraints[0];
                    // Handle empty values based on allowEmpty option
                    if (!value)
                        return allowEmpty;
                    try {
                        if (typeof value !== 'string')
                            return false;
                        if (requireE164) {
                            try {
                                (0, exports.normalizePhoneNumber)(value, { allowEmpty, requireE164 });
                                return true;
                            }
                            catch {
                                return false;
                            }
                        }
                        // Legacy callers may opt into regional parsing.
                        const cleanedNumber = value.replace(/[^\d+]/g, '');
                        // Parse and validate the phone number
                        const phoneNumber = (0, libphonenumber_js_1.default)(cleanedNumber, region);
                        // Basic validation
                        if (!phoneNumber?.isValid())
                            return false;
                        // Check if country code is required
                        if (!phoneNumber?.countryCallingCode)
                            return false;
                        return true;
                    }
                    catch (_error) {
                        return false;
                    }
                },
            },
        });
    };
}
